import { Component } from '@angular/core';
import { FooterComponent } from '../footer/footer.component';
import { NgClass } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-layout-no-header',
  standalone: true,
  imports: [
    FooterComponent,
    NgClass,
    RouterOutlet
  ],
  templateUrl: './layout-no-header.component.html',
  host: {
    class: 'layout layout-no-header'
  }
})
export class LayoutNoHeaderComponent {

}
